// extracted by mini-css-extract-plugin
module.exports = {"heading":"antd-pro-containers-product-add-styles-heading","checkBox":"antd-pro-containers-product-add-styles-checkBox"};